import {ReactNode} from 'react';
import {modals} from '@mantine/modals';
import {DocumentsService} from '../../api/generated/DocumentsService.ts';
import {notify} from '../../hooks/use-subscription.ts';

type OnClickDeleteProps = {
  title?: ReactNode;
  onConfirm: (() => void) | undefined;
  labels?: Record<'confirm' | 'cancel', ReactNode>;
};

export const onClickDelete = ({
  title,
  onConfirm,
  labels,
}: OnClickDeleteProps) => {
  modals.openConfirmModal({
    title,
    onConfirm,
    labels,
    confirmProps: {variant: 'danger'},
  });
};

export const onConfirmDelete = async (
  documentId: number,
  jobId: number | undefined,
  fetchJob: (jobId: number) => Promise<void>,
) => {
  await DocumentsService.deleteById({id: documentId});
  notify('document-listing', undefined);
  notify('review-log', undefined);
  jobId && (await fetchJob(jobId));
};
